import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH, MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID } from '../constants';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
function* handleInitCustomSetDeviationStream(action) {
    const deviations = action.payload;
    const streamId = MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID;
    const { result: ids , entities  } = normalizeDeviations(deviations);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    if (isStreamInitialized) {
        return;
    }
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            itemsPerFetch: DEVIATIONS_PER_FETCH,
            items: ids,
            entities
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitCustomSetDeviationStream;
